export default {
  tradeSummaries: [],
  tradeCount: null
};
